import type { FormField } from '@cli-types/core-engine/schema.js'

export function buildFieldArrayDecls(listFields: FormField[]): string {
  return listFields
    .map(
      (f) =>
        `  const ${f.name}FieldArray = useFieldArray({ control: form.control, name: '${f.name}' })`
    )
    .join('\n')
}
